import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TopMenu } from '../topmenu';
import { TopMenuItem } from '../../common/models/top-menu-item.model';

@Component({
    selector: 'app-top-bar',
    templateUrl: './top-bar.component.html'
})
export class TopBarComponent implements OnInit {
    topMenu: TopMenu;

    constructor(public router: Router) {
        this.topMenu = new TopMenu();
        this.topMenu.TopMenuItems = new Array<TopMenuItem>();
    }   

    ngOnInit() {
        this.initTopMenu();

        //top nav script
        function myFunction() {
            var x = document.getElementById("myTopnav");
            if (x.className === "topnav") {
                x.className += " responsive";
            } else {
                x.className = "topnav";
            }
        }
    }

    private initTopMenu() {
        let tmi1 = new TopMenuItem();
        tmi1.Key = "crm";
        tmi1.LinkUrl = "/home/crm";
        tmi1.Label = "CRM";

        let tmi2 = new TopMenuItem();
        tmi2.Key = "affiliate";
        tmi2.LinkUrl = "/home/affiliate";
        tmi2.Label = "affiliate";

        let tmi3 = new TopMenuItem();
        tmi3.Key = "customer";
        tmi3.LinkUrl = "/home/customer";
        tmi3.Label = "Customer";

        

        this.topMenu.TopMenuItems.push(tmi1);
        this.topMenu.TopMenuItems.push(tmi2);
        this.topMenu.TopMenuItems.push(tmi3);        
    } 
    
    doProfilePicChange(){

    }
    doLogout(){
        
    }
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/menus/top-bar/top-bar.component.ts